export default __webpack_public_path__ + "static/media/Blank-Standard.18cabf8e.png";